/** P2P relay for signature pad (separate peer id prefix from NID tool). */

import { createDesktopRelay, sendImagesToDesktop } from './nidPeerRelay';

export const SIGNATURE_PEER_PREFIX = 'ssig';

/**
 * Desktop relay — accepts exactly one successful file batch per session slug.
 */
export function createSignatureDesktopRelay(sessionSlug, onReceiveFiles) {
    let delivered = false;
    return createDesktopRelay(sessionSlug, (files) => {
        if (delivered) return;
        delivered = true;
        onReceiveFiles(files);
    }, SIGNATURE_PEER_PREFIX);
}

export function sendSignatureToDesktop(sessionSlug, files) {
    return sendImagesToDesktop(sessionSlug, files, SIGNATURE_PEER_PREFIX);
}
